<div class="{{ modalWrapperClass }}" id="u-verification-modal">
	<div class="u-ehe-modal">
		<div class="header-menu" *ngIf="title || showCloseIcon">
			<h4 *ngIf="title">{{ title }}</h4>
			<span class="close-icon" *ngIf="showCloseIcon"
				>|
				<i class="fa fa-times" aria-hidden="true" (click)="close()"></i>
			</span>
		</div>
		<div class="u-ehe-modal-body">
			<ng-content></ng-content>
		</div>
		<div class="u-ehe-modal-footer {{ !showButtons ? 'hide' : '' }}" *ngIf="showButtons">
			<div class="d-flex justify-content-left">
				<button class="button button-medium" mat-button (click)="submit()">{{ submitButton }}</button>
			</div>
		</div>
	</div>
</div>
